import React from 'react';
import {selectAuthorizedDomains} from 'state/environment/environmentSelectors';
import {load} from 'state/environment/environmentActions';
import {updateDisplayName, updateEmail} from 'state/invite/inviteActions';
import {
  isEmailDuplicate,
  isDisplayNameValid,
  isEmailValid,
  isAttempted,
  selectEmail,
  selectDisplayName,
} from 'state/invite/inviteSelectors';
import {connect} from 'react-redux';
import cx from 'classnames';
import EmailInput from './EmailInput';
import {FormattedMessage} from 'react-intl';
import './InviteUserForm.css';

class InviteUserForm extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.load();
  }

  handleDisplayNameChange = e => {
    this.props.updateDisplayName(e.target.value);
  };

  handleEmailChange = email => {
    this.props.updateEmail(email);
  };

  open() {
    this.refs.modal.open();
  }

  render() {
    const showDisplayNameErrors =
      this.props.isAttempted && !this.props.isDisplayNameValid;
    const showEmailErrors =
      this.props.isAttempted &&
      (!this.props.isEmailValid || this.props.isEmailDuplicate);
    const displayNameErrors = showDisplayNameErrors ? (
      <div className="InviteUserForm__ErrorMessage">
        <FormattedMessage
          id="InviteUserForm__InvalidDisplayName"
          description="Error indicating that the invitee name is invalid"
          defaultMessage="Name is required"
        />
      </div>
    ) : null;
    const emailErrors = showEmailErrors ? (
      <div className="InviteUserForm__ErrorMessage">
        {this.props.isEmailValid ? null : (
          <FormattedMessage
            id="InviteUserForm__InvalidEmail"
            description="Error indicating that the invitee email adress is invalid"
            defaultMessage="A valid email is required"
          />
        )}
        {this.props.isEmailDuplicate ? (
          <FormattedMessage
            id="InviteUserForm__DuplicateEmail"
            description="Error indicating that the invitee email address already has an account"
            defaultMessage="An account already exists for that email"
          />
        ) : null}
      </div>
    ) : null;

    return (
      <div>
        <div className="InviteUserForm__FormGroup">
          <div className="InviteUserForm__FormGroupTitle">
            <FormattedMessage
              id="InviteUserForm__DisplayName"
              description="Label for Name field on Invite to Domo form"
              defaultMessage="Name"
            />
          </div>
          <input
            className={cx({
              InviteUserForm__Input: true,
              'InviteUserForm__Input--invalid': showDisplayNameErrors,
            })}
            onChange={this.handleDisplayNameChange}
            value={this.props.displayName}
          />
          {displayNameErrors}
        </div>
        <div className="InviteUserForm__FormGroup">
          <div className="InviteUserForm__FormGroupTitle">
            <FormattedMessage
              id="InviteUserForm__Email"
              description="Label for Email field on Invite to Domo form"
              defaultMessage="Email"
            />
          </div>
          <EmailInput
            domains={this.props.domains}
            email={this.props.email}
            onEmailChange={this.handleEmailChange}
            invalid={showEmailErrors}
          />
          {emailErrors}
        </div>
      </div>
    );
  }
}
export default connect(
  state => ({
    domains: selectAuthorizedDomains(state),
    isDisplayNameValid: isDisplayNameValid(state),
    isEmailValid: isEmailValid(state),
    isEmailDuplicate: isEmailDuplicate(state),
    isAttempted: isAttempted(state),
    displayName: selectDisplayName(state),
    email: selectEmail(state),
  }),
  {
    load,
    updateDisplayName,
    updateEmail,
  }
)(InviteUserForm);
